import { registerIcon } from "@ui5/webcomponents-base/dist/asset-registries/Icons.js";

const name = "open-command-field";
const pathData = "M233 87q-9-9-9-22.5t9-22.5q10-10 23-10t23 10l192 192q9 9 9 22.5t-9 22.5L280 472q-10 10-23 10t-22-10q-10-9-10-22t10-23l157-159q11-11 0-23zM40 87q-9-9-9-22.5T40 42q10-10 23-10t23 10l192 192q9 9 9 22.5t-9 22.5L87 472q-10 10-23 10t-22-10q-10-9-10-22t10-23l157-159q11-11 0-23z";
const ltr = false;
const accData = null;
const collection = "SAP-icons-v4";
const packageName = "@ui5/webcomponents-icons";

registerIcon(name, { pathData, ltr, collection, packageName });

export default "SAP-icons-v4/open-command-field";
export { pathData, ltr, accData };